if (!customElements.get('card-image-gallery')) {
  customElements.define(
    'card-image-gallery',
    class CardImageGallery extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[data-gallery-slides]');
        this.slides = this.querySelectorAll('[data-gallery-slide]');
        this.prevBtn = this.querySelector('[data-gallery-prev]');
        this.nextBtn = this.querySelector('[data-gallery-next]');

        if (!this.slider || this.slides.length < 2) return;

        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.navigate(-1);
        });

        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.navigate(1);
        });

        this.slider.addEventListener('scroll', () => this.updateButtons());
        this.updateButtons();

        this.initDrag();
      }

      navigate(direction) {
        const slideWidth = this.slides[0].clientWidth;
        this.slider.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
      }

      updateButtons() {
        const scrollLeft = this.slider.scrollLeft;
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        this.prevBtn.toggleAttribute('disabled', scrollLeft <= 1);
        this.nextBtn.toggleAttribute('disabled', scrollLeft >= maxScroll - 1);
      }

      initDrag() {
        this.isDragging = false;
        this.hasDragged = false;
        this.startX = 0;
        this.scrollStart = 0;

        this.slider.addEventListener('mousedown', (e) => {
          this.isDragging = true;
          this.hasDragged = false;
          this.startX = e.pageX;
          this.scrollStart = this.slider.scrollLeft;
          this.slider.classList.add('is-dragging');
        });

        this.slider.addEventListener('mousemove', (e) => {
          if (!this.isDragging) return;
          e.preventDefault();
          const dx = e.pageX - this.startX;
          if (Math.abs(dx) > 5) this.hasDragged = true;
          this.slider.scrollLeft = this.scrollStart - dx;
        });

        const stopDrag = () => {
          if (!this.isDragging) return;
          this.isDragging = false;
          this.slider.classList.remove('is-dragging');
          // Re-enable scroll-snap so it settles to nearest slide
          this.slider.scrollLeft = this.slider.scrollLeft;
        };

        this.slider.addEventListener('mouseup', stopDrag);
        this.slider.addEventListener('mouseleave', stopDrag);

        // Prevent link navigation after a drag
        this.slider.addEventListener('click', (e) => {
          if (this.hasDragged) {
            e.preventDefault();
            e.stopPropagation();
            this.hasDragged = false;
          }
        });
      }
    }
  );
}
